import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { formatCurrency } from '@/domains/core/localization/currency';
import { isB2B } from '@/domains/core/settings/utils';
import { Button } from '@/domains/core/tamagoshiTailwind/components/Button/Button';
import { signIn } from '@/domains/customerManagement/auth/services/client';
import {
  createAccountCta,
  loyaltyCardWelcomeOffer,
} from '@/domains/loyalty/modules/LoyaltyProgramHvc/components/LoyaltyProgramCard/translations';
import { loyaltyCardContentFormatter } from '@/domains/loyalty/modules/LoyaltyProgramHvc/components/LoyaltyProgramCard/utils';
import { useLoyaltyProgramHvcWelcomeOffer } from '@/domains/loyalty/modules/LoyaltyProgramHvc/hooks/useLoyaltyProgramHvcWelcomeOffer';
import { ABTests } from '@/domains/proB2BAnimation/abtests';

export const LoyaltyProgramCardUnauthenticatedContent = () => {
  const [unified] = useBooleanFlags([ABTests.PEPE_UNIFY_AUTH]);
  const welcomeOfferAmount = useLoyaltyProgramHvcWelcomeOffer();

  return (
    <div className="flex flex-col gap-s">
      <div className="flex items-baseline gap-xs">
        {!!welcomeOfferAmount &&
          loyaltyCardWelcomeOffer.format(
            loyaltyCardContentFormatter({
              amount: formatCurrency(welcomeOfferAmount, undefined, {
                minimumFractionDigits: 0,
              }),
            }),
          )}
      </div>
      <Button
        onClick={() => {
          signIn({
            b2b: isB2B(),
            unified,
          });
        }}
        variant="secondary"
        size="M"
        text={createAccountCta}
      />
    </div>
  );
};

LoyaltyProgramCardUnauthenticatedContent.displayName =
  'LoyaltyProgramCardUnauthenticatedContent';
